import { LayerDefinitionDc } from "@evergis/api";
import { useMemo } from "react";
import { DEFAULT_ID_ATTRIBUTE_NAME, GEOMETRY_ATTRIBUTE } from "../../evergis/constants";
import { FeatureDcExtended } from "../../ducks/selectFeatures/types";
import { isSelectedFeature } from "../../ducks/selectFeatures/utils";

export const useFeatureLayerDefinition = (feature: FeatureDcExtended): LayerDefinitionDc =>
  useMemo((): LayerDefinitionDc => {
    if (isSelectedFeature(feature)) {
      return feature.layerDefinition;
    }

    return {
      attributes: {},
      geometryAttribute: GEOMETRY_ATTRIBUTE,
      idAttribute: DEFAULT_ID_ATTRIBUTE_NAME,
    };
  }, [feature]);
